import { j as s } from "../../../../../../jsx-runtime.BREq8dyb.js";
import { Select as i, Option as e, Box as n } from "@mui/joy";
import { memo as d } from "react";
import { ShowColumns as l } from "../../../../types/index.js";
const o = () => /* @__PURE__ */ s.jsxs(n, { sx: {
  display: "flex",
  gap: "0.25rem"
}, children: [
  /* @__PURE__ */ s.jsx("span", { style: {
    fontWeight: 500
  }, children: "All" }),
  /* @__PURE__ */ s.jsx("span", { children: "columns" })
] }), a = () => /* @__PURE__ */ s.jsxs(n, { sx: {
  display: "flex",
  gap: "0.25rem"
}, children: [
  /* @__PURE__ */ s.jsx("span", { style: {
    fontWeight: 500
  }, children: "Mapped" }),
  /* @__PURE__ */ s.jsx("span", { children: "columns" })
] }), p = () => /* @__PURE__ */ s.jsxs(n, { sx: {
  display: "flex",
  gap: "0.25rem"
}, children: [
  /* @__PURE__ */ s.jsx("span", { style: {
    fontWeight: 500
  }, children: "Unmapped" }),
  /* @__PURE__ */ s.jsx("span", { children: "columns" })
] }), c = d(({
  disabled: x = !1,
  showColumns: r,
  setShowColumns: m
}) => /* @__PURE__ */ s.jsxs(i, { disabled: x, onChange: (h, t) => m(t), value: r, children: [
  /* @__PURE__ */ s.jsx(e, { label: /* @__PURE__ */ s.jsx(o, {}), value: l.All, children: /* @__PURE__ */ s.jsx(o, {}) }),
  /* @__PURE__ */ s.jsx(e, { label: /* @__PURE__ */ s.jsx(a, {}), value: l.Mapped, children: /* @__PURE__ */ s.jsx(a, {}) }),
  /* @__PURE__ */ s.jsx(e, { label: /* @__PURE__ */ s.jsx(p, {}), value: l.Unmapped, children: /* @__PURE__ */ s.jsx(p, {}) })
] }));
c.displayName = "ShowColumnsSelect";
export {
  c as default
};
//# sourceMappingURL=ShowColumnsSelect.js.map
